import React from "react";
import { InventoryView } from "../features/inventory/InventoryView";
import { withRestaurantId } from "../shared/components/layout";

const InventoryViewWithId = withRestaurantId(InventoryView);

const InventoryPage: React.FC = () => {
  return <InventoryViewWithId />;
};

export default InventoryPage;
